import { produce } from 'immer';
import { useCallback, useMemo } from 'react';
import { useMount } from 'react-use';
import { organizationStorageApi, } from 'apis/organizationStorage';
import { userStorageApi } from 'apis/userStorage';
/**
 * Wraps {@link userStorageApi} and {@link organizationStorageApi} and provides
 * their data and functions to mutate data.
 */
export const useServerStorage = (scope) => {
    const [readUserStorage, readUserStorageResponse] = userStorageApi.useLazyReadUserStorageQuery();
    const [setUserStorage] = userStorageApi.useSetUserStorageMutation();
    const [readOrganizationStorage, readOrganizationStorageResponse] = organizationStorageApi.useLazyReadOrganizationStorageQuery();
    const [setOrganizationStorage] = organizationStorageApi.useSetOrganizationStorageMutation();
    const isUserScope = scope === 'user';
    const readServerStorage = isUserScope
        ? readUserStorage
        : readOrganizationStorage;
    const setServerStorage = isUserScope
        ? setUserStorage
        : setOrganizationStorage;
    const readServerStorageResponse = isUserScope
        ? readUserStorageResponse
        : readOrganizationStorageResponse;
    const data = useMemo(() => readServerStorageResponse.data, [readServerStorageResponse.data]);
    const read = useCallback((preferCache = true) => {
        readServerStorage({}, preferCache);
    }, [readServerStorage]);
    const refetch = useCallback(() => {
        read(false);
    }, [read]);
    const set = useCallback((patch) => {
        const payload = Object.fromEntries(Object.entries(patch).map(([key, produceFn]) => {
            var _a;
            return [key, produce((_a = data[key]) !== null && _a !== void 0 ? _a : {}, produceFn)];
        }));
        setServerStorage(payload);
    }, [data, setServerStorage]);
    const remove = useCallback((keys) => {
        const payload = Object.fromEntries(keys.map((key) => [key, null]));
        setServerStorage(payload);
    }, [setServerStorage]);
    useMount(() => {
        read();
    });
    return useMemo(() => ({ data, refetch, set, remove }), [refetch, data, remove, set]);
};
